import styled from "styled-components";
import worldcupstatus from "../../../../assets/images/worldcup_status.png";

const TravelInsuranceSuccessWrapper = styled.div`
  .container-fluid {
    background: #e5e5e5;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 88vh;
  }
  .iconStyle {
    // padding-top: 181px;
    // padding-bottom: 79px;
  }

  .buttonStyle {
    margin-top: 30px;
    margin-bottom: 40px;
    height: 48px;
    background: #6B47F5;
    border-radius: 5px;
    border-color: #6B47F5;
  }
  .buttonStyle:hover {
    background: #cd8836;
    border-color: #6B47F5;
  }
  .messageStyle {
    padding-top: 30px;
    font-size: 17px;
    font-weight: 400;
  }

  .textStyle {
    font-size: 1.5rem;
    font-weight: 800;
    color: #34a853;
  }
  .backLinkStyle {
    font-size: 18px;
    font-weight: 800;
    color: #6B47F5;
    text-transform: uppercase;
  }
  .elementWrapper {
    padding: 1.5rem 0;
    /* min-height: 88vh; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  }
  .labelStyle {
    font-size: 18px;
    font-weight: 800;
    margin-left: 14px;
    margin-right: 14px;
    margin-top: 12px;
  }
  .backTextStyle {
    font-size: 18px;
  }
  .worldcup_success_wrapper {
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
    border-radius: 10px;
    margin-top: 5rem;
    padding-bottom: 5rem;

    .worldcup_banner {
      p, h5 {
        margin: 0;
      }
      h5 {
        font-size: 1.3rem;
      }
      p {
        font-size: 0.8rem;
      }
      background-image: url(${worldcupstatus});
      width: 800px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      display: flex;
      align-items: center;
      color: #ffffff;
      padding: 2rem 3rem;
      text-align: left;

      div {
        margin: 0 10px;
        // padding: 1rem 0;
      }
    }
    .elementWrapper {
      .iconStyle {
        img {
          height: 100px;
        }
      }
      .textStyle {
        font-size: 1.5rem; 
      }
    }
    
  }
  .worldcup_sadad_payment_info {
    color: #EF2F2F;
    margin-top: 1rem;
    margin-bottom: 0;
  }
  .download-link {
    text-decoration: none;
  }
  .download {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding: 24px;
    gap: 24px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 50px;
  }
  .policy-download {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .policy-download-title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #1A1C1F;
  }
  .policy-download-description {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: #1A1C1F;
  }
  @media screen and (max-width: 768px) {
    .container-fluid {
      min-height: 70vh;
    }
    .textStyle {
      font-size: 22px;
    }
    .messageStyle {
      font-size: 15px;
    }
    .backLinkStyle {
      font-size: 17px;
    }
    .buttonStyle {
      width: 234px;
      height: 48px;
    }
    .labelStyle {
      font-size: 14px;
      .backTextStyle {
        font-size: 14px;
      }
    }
  }
`;

export default TravelInsuranceSuccessWrapper;
